// MA-894 RED SHOULD-1 (operator decision D-1019-20) — the Badges tab's gold dot,
// from LOCAL stores only: no fetch, no tree, no Journey view, no writes.
//
// Held records = the badge_earned latch rows in the local milestone mirror (every
// record any useBadges mount has latched on this device) ∪ the practice-day badge
// instances the local session_completed markers already earn (a session finished
// on this device mirrors its marker locally first, so a new practice-day badge
// dots before the book is opened). A skill or trophy record dots once it is
// latched (the book's own mount latches it; MA-895's recap will too). The count
// can only under-read a device that holds less history than the cloud; it never
// invents a record. Seen = the MA-892 seen store (never opened → every held
// record is unseen, as useBadges reads it).

import { latchedBadgeIdsFromEvents, loadLocalBadgeSourceEvents, newlyEarnedSince, readBadgesSeen, sessionCompletedTimes } from "./persistence";
import { dayBadgeInstances, practiceDayCount } from "./rules";

/** Held badge records from the local mirror alone (see the header). */
export function localHeldBadgeRecords(localChildId: string | null | undefined): string[] {
  if (!localChildId) return [];
  const events = loadLocalBadgeSourceEvents(localChildId);
  const latched = latchedBadgeIdsFromEvents(events);
  const days = dayBadgeInstances(practiceDayCount(sessionCompletedTimes(events)));
  return [...new Set([...latched, ...days])];
}

/** How many held records the child has not seen in the book yet. */
export function unseenBadgeRecordCount(localChildId: string | null | undefined): number {
  if (!localChildId) return 0;
  return newlyEarnedSince(localHeldBadgeRecords(localChildId), readBadgesSeen(localChildId)).length;
}
